const DO_NOT_TRACK_LIST = ['/erbjudanden'];

const shouldTrackPageView = (url: string, previousUrl?: string) => {
  if (DO_NOT_TRACK_LIST.includes(url)) return false;
  if (url === previousUrl) return false;
  return true;
};

export default shouldTrackPageView;
